import PropTypes from "prop-types"

import { ItemTitle } from "areas/cart/components"
import Financing from "areas/product/jewlr/wizard-header/financing"
import { IS_JEWLR } from "helpers/application"

import Price from "./jewlr/price"
import LineItemShipping from "./line-item-shipping"

const LineItemInfo = ({ item }) => {
  return (
    <div className="flex-1">
      <ItemTitle data-cy="cart-line-item-info-title">{item.title}</ItemTitle>
      {item.in_stock && (
        <>
          <Price item={item} />
          {IS_JEWLR() && (
            <Financing inCart price={Math.round(item.price * 100)} />
          )}
          <LineItemShipping item={item} />
        </>
      )}
    </div>
  )
}

LineItemInfo.propTypes = {
  handleRemoveClick: PropTypes.func,
  item: PropTypes.object,
}

export default LineItemInfo
